import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import ContainerLayout from "../../../../components/container-layout/ContainerLayout";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../../routes/routeName";
import SpecailEditProject from "../components/table/SpecailEditProject";
import { useLocation } from "react-router-dom";


const EdpexSpecialEditRequest = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <>
      <ContainerLayout
        title={t("การขอแก้ไขพิเศษ")}
        navigateContent={
          <NavigateListCustom
            navigateData={[
              {
                key: "1",
                name: t("ระบบ Edpex"),
                disabled_match: true,
                pathName: "",
              },
              {
                key: "2",
                name: t("การขอแก้ไขพิเศษ"),
                pathName: pathname
              },
            ]}
          />
        }
        content={<SpecailEditProject isApprove={true} />}
      />
    </>
  );
};

export default EdpexSpecialEditRequest;
